<template>
  <div
    class="bg-white-500 flex w-fit rounded-l-md text-neutral-950 shadow-lg"
    :data-testid="`${variant}-toast`"
  >
    <div
      class="h-full w-[4px] rounded-l-md"
      :class="targetConfig.barClass"
    ></div>
    <div class="flex grow items-center justify-start gap-3 p-4">
      <TIcon
        :name="targetConfig.icon"
        :height="32"
        :width="32"
        :class="[targetConfig.iconClass]"
      />

      <div class="grow">
        <p :class="['text-sm font-bold']">
          {{ props.header ?? targetConfig.header }}
        </p>
        <span class="text-sm font-normal">
          {{ props.description }}
        </span>
      </div>
      <TButton
        type="tonal"
        color="neutral"
        name="close"
        class="ml-6"
        icon="close"
        @click="toast.dismiss()"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import { computed } from 'vue';
import TButton from '../Button/TButton.vue';
import type { IconType } from '../Icon/icon';
import TIcon from '../Icon/TIcon.vue';
import { useToast } from './useToast';

type ToastVariant = 'info' | 'error' | 'success';
const props = withDefaults(
  defineProps<{
    variant: ToastVariant;
    description: string;
    header?: string;
    hideCloseButton?: boolean;
  }>(),
  {
    hideCloseButton: false,
    header: undefined,
  },
);
const toast = useToast();

type ToastConfigType = Record<
  ToastVariant,
  {
    icon: IconType;
    barClass: string;
    iconClass: string;
    header?: string;
    dataTestType?: string;
  }
>;

const toastConfig: ToastConfigType = {
  info: {
    icon: 'circular_info',
    barClass: 'bg-primary-500',
    iconClass: 'text-primary-500 shrink-0',
    header: $t('info'),
    dataTestType: 'Info',
  },
  error: {
    icon: 'circular_cancel',
    barClass: 'bg-danger-500',
    iconClass: 'text-danger-500 shrink-0',
    header: $t('error'),
    dataTestType: 'Error',
  },
  success: {
    icon: 'check_circle',
    barClass: 'bg-success-500',
    iconClass: 'text-success-500 shrink-0',
    header: $t('success'),
    dataTestType: 'Success',
  },
};

const targetConfig = computed(() => toastConfig[props.variant]);
</script>
